import React from 'react';
import { viewContext } from "../../App";
import DobForm from '../displaycomponents/DobForm';
import PartnerInfo from './PartnerInfo';
import {DOB,HOME} from "../../Utils/constants.js";

function PartnerCompatibility (){
	const {state} = React.useContext(viewContext);
	let currentComponent;
	if(DOB.test(state.view))
		currentComponent = <PartnerInfo/>;
	else if(state.view===HOME)
		currentComponent = <div className='mainContainer'> </div>
	else
		currentComponent = <DobForm/>; 
	return(
		<>
			{currentComponent}
		</>
	);
}

export default PartnerCompatibility;